import React from 'react';
import ExperienceRiskBadge from './ExperienceRiskBadge';

const CustomerExperienceTable = ({ records = [] }) => (
  <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
    <h3 className="mb-3 text-sm font-semibold text-slate-100">Customer Experience Table</h3>
    <div className="overflow-x-auto">
      <table className="min-w-full text-left text-xs text-slate-300">
        <thead>
          <tr className="text-slate-400">
            <th className="px-2 py-1">Customer</th>
            <th className="px-2 py-1">Area</th>
            <th className="px-2 py-1">Experience</th>
            <th className="px-2 py-1">Komplain</th>
            <th className="px-2 py-1">Churn</th>
            <th className="px-2 py-1">Issue</th>
            <th className="px-2 py-1">Tindakan Rekomendasi</th>
          </tr>
        </thead>
        <tbody>
          {records.map((row) => (
            <tr key={`cx-${row.customerId}`} className="border-t border-slate-800/70">
              <td className="px-2 py-1.5 font-medium text-slate-100">{row.customerId}</td>
              <td className="px-2 py-1.5">{row.areaName || '-'}</td>
              <td className="px-2 py-1.5"><ExperienceRiskBadge level={row.experienceLevel} /></td>
              <td className="px-2 py-1.5"><ExperienceRiskBadge level={row.complaintRiskLevel} /></td>
              <td className="px-2 py-1.5"><ExperienceRiskBadge level={row.churnRiskLevel} /></td>
              <td className="px-2 py-1.5">{row.primaryIssueType}</td>
              <td className="px-2 py-1.5 text-slate-400">{row.recommendedAction}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {!records.length ? <div className="px-2 py-2 text-xs text-slate-500">Tidak ada data customer experience.</div> : null}
    </div>
  </section>
);

export default CustomerExperienceTable;
